import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * This class as a wrapper is required so we can pass
 * index as a reference and not a value
 */
export var ParsedItemIndexReferenceWrapper =
/*#__PURE__*/
function () {
  function ParsedItemIndexReferenceWrapper(index) {
    _classCallCheck(this, ParsedItemIndexReferenceWrapper);

    this.index = index;
  }

  _createClass(ParsedItemIndexReferenceWrapper, [{
    key: "increment",
    value: function increment() {
      this.index++;
    }
  }]);

  return ParsedItemIndexReferenceWrapper;
}();